import React from "react";
import Slider from "react-slick";
import { useData } from "../../context/DataContext";

const Banners = () => {
  const { thank_you_banners } = useData();
  return (
    <Slider autoplay={true} autoplaySpeed={3000} pauseOnHover={false}>
      {thank_you_banners?.photos?.map((el) => {
        return (
          <div className="">
            {el.type === "image" ? (
              <img className="w-100 cover" src={el.src} alt={el.src} />
            ) : el.type === "video" ? (
              <video
                autoPlay
                loop
                playsInline
                className={"w-100 cover"}
                src={el?.src}
              ></video>
            ) : (
              <div>The File You've uploaded is not Correct</div>
            )}
          </div>
        );
      })}
    </Slider>
  )
};


const ThankYou = () => {
  return <div>
		<Banners />
	</div>;
};

export default ThankYou;
